<template>
  <div id="admin_rpts_businesses_daily_reg_rpt">
    <CardedSectionHeader
      icon="mdi-form-map"
      label="Report Filter"
      id="admin_registrations_report_filter"
    ></CardedSectionHeader>
    <CardedForm
      ref="admin_registrations_report_filter_form_ref"
      id="admin_registrations_report_filter_form"
      title="You can filter by: start date, end date, category, sub catgory and location"
      :is_loading="is_loading"
      @on-submit-form="filter_report"
      :errors="errors"
      :message="message"
      @on-auto-fill="on_auto_fill"
      cmp_class="ma-0 pl-5 pr-5 pt-0 white"
      @on-clear-form="on_clear_form"
    >
      <v-row no-gutterss class="pa-0 mb-0" :key="date_input_key">
        <v-col class="pt-0 pb-0 mb-0">
          <DateField
            label="Start Date"
            v-model="form.start_date_display"
            :disabled="is_loading"
            :validation_rules="form_validations.start_date_display"
            :min="'2018-01-01'"
            :max="form.date_today"
          ></DateField>
        </v-col>
        <v-col class="pt-0 pb-0 mb-0">
          <DateField
            label="End Date"
            v-model="form.end_date_display"
            :disabled="is_loading"
            :validation_rules="form_validations.end_date_display"
            :min="form.start_date_display"
            :max="form.date_today"
          ></DateField>
        </v-col>
      </v-row>
      <v-row no-gutterss class="pa-0 mb-0">
        <v-col class="pt-0 pb-0 mb-0">
          <SelectField
            v-model="form.category_id"
            :options="categories"
            :small_chips="false"
            :is_small="true"
            :validation_rules="form_validations.category_id"
            label="Category"
            icon="mdi-group"
            :disabled="is_loading"
            item_text="name"
            item_value="id"
          ></SelectField>
        </v-col>
        <v-col class="pt-0 pb-0 mb-0">
          <SelectField
            v-model="form.sub_category_id"
            :options="sub_categories"
            :small_chips="false"
            :is_small="true"
            :validation_rules="form_validations.sub_category_id"
            label="Sub Category"
            icon="mdi-group"
            :disabled="is_loading"
            item_text="name"
            item_value="id"
          ></SelectField>
        </v-col>
      </v-row>
      <v-row no-gutterss class="pa-0 mb-0">
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <SelectField
            v-model="form.district_id"
            :options="districts"
            :small_chips="false"
            :validation_rules="form_validations.district_id"
            label="District"
            icon="mdi-pen-plus"
            :disabled="is_loading"
            item_text="name"
            item_value="id"
          ></SelectField>
        </v-col>
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <SelectField
            v-model="form.city_id"
            :options="cities"
            :small_chips="false"
            :validation_rules="form_validations.city_id"
            label="City"
            icon="mdi-pen-plus"
            :disabled="is_loading"
            item_text="name"
            item_value="id"
          ></SelectField>
        </v-col>
      </v-row>
      <v-row no-gutterss class="pa-0 mb-0">
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <SelectField
            v-model="form.ward_id"
            :options="wards"
            :small_chips="false"
            :validation_rules="form_validations.ward_id"
            label="Ward"
            icon="mdi-pen-plus"
            :disabled="is_loading"
            item_text="name"
            item_value="id"
          ></SelectField>
        </v-col>
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <SelectField
            v-model="form.street_id"
            :options="streets"
            :small_chips="false"
            :validation_rules="form_validations.street_id"
            label="Street"
            icon="mdi-pen-plus"
            :disabled="is_loading"
            item_text="name"
            item_value="id"
          ></SelectField>
        </v-col>
      </v-row>
      <TextField
        v-model="form.physical_address"
        :validation_rules="form_validations.physical_address"
        label="Physical Address: (e.g plot 22211 phase 4, Gaborone) Or Manual Directions"
        icon="mdi-pen-plus"
        :disabled="is_loading"
      ></TextField>
    </CardedForm>
    <CardedSectionHeader
      icon="mdi-form-map"
      label="Report Table"
      id="admin_registrations_report_table"
    ></CardedSectionHeader>
    <CardedTable
      :items="items"
      :headers="headers"
      :show_search="true"
      :show_description="false"
      :show_header_bar="true"
      :has_margin="false"
    >
      <template v-slot:controls>
        <div>
          <h4 class="pt-3">{{ report_message }}</h4>
        </div>
      </template>

      <template v-slot:[`item.owners_name`]="{ item }">
        {{ item.user.first_name }} {{ item.user.last_name }}
      </template>

      <template v-slot:[`item.is_verified`]="{ item }">
        <span class="red--text" v-if="parseInt(item.is_verified) == 0"
          ><b>Pending</b></span
        >
        <span class="blue--text" v-if="parseInt(item.is_verified) == 1"
          ><b>Processing</b></span
        >
        <span class="green--text" v-if="parseInt(item.is_verified) == 2"
          ><b>Verified</b></span
        >
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-btn @click="on_view_item(item)" x-small rounded text color="success">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </template>
    </CardedTable>
  </div>
</template>

<script>
import CardedTable from "../../../components/CardedTable";
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import CardedForm from "../../../components/CardedForm";
import SelectField from "../../../components/SelectField";
import TextField from "../../../components/TextField";
import RedText from "../../../components/RedText";
import DateField from "../../../components/DateField";
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
export default {
  name: "AdminReportsRegistrations",
  components: {
    CardedTable,
    DateField,
    RedText,
    SelectField,
    CardedSectionHeader,
    CardedForm,
    TextField
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => {
        return ServerClient.Login.get_logged_in_user();
      },
    },
  },
  data: () => {
    return {
      _user: null,
      errors: [],
      message: "",
      form: {
        start_date_display: Utils.get_today_date_str(),
        end_date_display: Utils.get_today_date_str(),
        date_today: Utils.get_today_date_str(),
        category_id: null,
        sub_category_id: null,
        district_id: null,
        city_id: null,
        ward_id: null,
        street_id: null,
        physical_address: ""
      },
      form_validations: {
        start_date_display: [],
        end_date_display: [],
        category_id: [],
        district_id: [],
        city_id: [],
        ward_id: [],
        street_id: [],
        physical_address: []
      },
      items: [],
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: true,
          value: "name",
          filterable: true,
        },
        {
          text: "Owner",
          align: "start",
          sortable: true,
          value: "owners_name",
          filterable: false,
        },
        {
          text: "User Name",
          align: "start",
          sortable: true,
          value: "user.email",
          filterable: true,
        },
        {
          text: "Join Date",
          align: "start",
          sortable: true,
          value: "joined_on",
          filterable: true,
        },
        {
          text: "Verification",
          align: "start",
          sortable: true,
          value: "is_verified",
          filterable: true,
        },
        { text: "", value: "actions", sortable: false, align: "end" },
      ],
      categories: [],
      districts: [],
      report_message: "",
      date_input_key: "date_inputs_key_1",
      date_input_key_truck : 1
    };
  },
  methods: {
    on_clear_form(){
      this.form.start_date_display =  Utils.get_today_date_str();
      this.form.end_date_display = Utils.get_today_date_str();
      this.form.category_id = null;
      this.form.sub_category_id = null;
      this.form.district_id = null;
      this.form.city_id = null;
      this.form.ward_id = null;
      this.form.street_id = null;
      this.form.physical_address = "";
      this.date_input_key_truck = this.date_input_key_truck + 1;
      this.date_input_key = "date_inputs_key_" + this.date_input_key_truck;
      // console.log("Assigned here", this.form);
    },
    on_auto_fill() {
        this.refresh_table();
    },
    filter_report() {
        this.refresh_table();
    },
    get_report_dependencies() {
      ServerClient.Reports.get_register_reports_dependencies(
        {
        },
        (res) => {
          this.categories = res.categories;
          if (this.categories.length > 0) {
            this.category_id = this.categories[0].id;
            if (this.categories[0].sub_categories.length > 0) {
              this.sub_category_id = this.categories[0].sub_categories[0].id;
            }
          }
          this.districts = res.districts;
          this.refresh_table();
        },
        (errors) => {
          this.errors = errors;
          this.$refs.owner_register_business_form_ref.show_error_dialog();
        }
      );
    },
    load_items(filter_config) {
      this.$emit("on-show-loader");
      ServerClient.Reports.get_registrations_report(
        {
          ...filter_config
        },
        (res) => {
          this.items = res;
          this.process_report_message();
          this.$emit("on-hide-loader");
          var options = {
            offset: 50,
            duration: 1000,
            easing: "easeInOutCubic",
          };
            this.$vuetify.goTo("#admin_registrations_report_table", options);
        },
        (errors) => {
          this.$emit("on-hide-loader");
          this.errors = errors;
          this.$refs.admin_registrations_report_filter_form.show_error_dialog();
        }
      );
    },
    on_view_item(item) {
      this.$router.push("/admin/businesses/list/view/" + item.id);
    },
    refresh_table() {
      this.errors = [];
      var start_time_str = this.form.start_date_display + " 00:30:00 AM ";
      var start_time = Utils.date_str_to_php_time(start_time_str);
      var end_time_str = this.form.end_date_display + " 11:30:00 PM ";
      var end_time = Utils.date_str_to_php_time(end_time_str);
      if (start_time == end_time) {
        this.errors.push("Start time cannot be equal to end time");
        this.$refs.admin_registrations_report_filter_form.show_error_dialog();
        return false;
      }
      if (start_time > end_time) {
        this.errors.push("Start time cannot be greater than end time");
        this.$refs.admin_registrations_report_filter_form.show_error_dialog();
        return false;
      }

      this.load_items({
          ...this.form,
      });
    },
    process_report_message() {
      var num_str = "";
      if (this.items.length == 0) {
        num_str = " were no  businesses ";
      } else if (this.items.length == 1) {
        num_str = " was only (1) one business ";
      } else if (this.items.length > 1) {
        num_str = " were " + this.items.length + " businesses ";
      }

      var start_word = Utils.date_str_to_words(
        this.form.start_date_display,
        true,
        "of"
      );
      var end_word = Utils.date_str_to_words(this.form.end_date_display, true, "of");
      var msg = "";
      if (this.form.start_date_display == this.form.end_date_display) {
        msg = "There " + num_str + " registered on the " + start_word;
      } else {
        msg =
          "There " +
          num_str +
          " registered between the " +
          start_word +
          " and the " +
          end_word;
      }
      this.report_message = msg;
    },
  },
  computed: {
    sub_categories() {
      var temp = [];
      for (var index = 0; index < this.categories.length; index++) {
        var cat = this.categories[index];
        if (parseInt(cat.id) == parseInt(this.category_id)) {
          temp = cat.sub_categories;
          break;
        }
      }
      return temp;
    },
    cities() {
      var temp = [];
      for (var index = 0; index < this.districts.length; index++) {
        var district = this.districts[index];
        if (parseInt(district["id"]) == parseInt(this.form.district_id)) {
          temp = district.cities;
          break;
        }
      }
      return temp;
    },
    wards() {
      var temp = [];
      for (var index = 0; index < this.districts.length; index++) {
        var district = this.districts[index];
        if (parseInt(district["id"]) == parseInt(this.form.district_id)) {
          temp = district.wards;
          break;
        }
      }
      return temp;
    },
    streets() {
      var temp = [];
      for (var index = 0; index < this.districts.length; index++) {
        var district = this.districts[index];
        var found = false;
        if (parseInt(district["id"]) == parseInt(this.form.district_id)) {
          var wards = district.wards;
          for (var index2 = 0; index2 < wards.length; index2++) {
            var ward = wards[index2];
            if (parseInt(ward.id) == parseInt(this.form.ward_id)) {
              temp = ward.streets;
              found = true;
              break;
            }
          }
        }
        if (found == true) {
          break;
        }
      }
      return temp;
    },
  },
  mounted() {
    this._user = ServerClient.Login.get_logged_in_user();
    //nyd
    //if is not admin please redirect this user to the login screen

    this.$emit("set-page-attributes", {
      title: "Registrations Report",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Reports",
          disabled: false,
          href: "/admin/reports",
        },
        {
          text: "Regestrations Report",
          disabled: true,
          href: "/admin/reports/registrations",
        },
      ],
    });

    this.get_report_dependencies();

    var options = {
      offset: 50,
      duration: 1000,
      easing: "easeInOutCubic",
    };
    this.$vuetify.goTo("#admin_rpts_businesses_daily_reg_rpt", options);
  },
};
</script>